<template>
  <router-view />
</template>

<script>
    export default {
        name: "TeamContainer"
    }
</script>

<style scoped>

</style>